import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { from, Observable, of } from 'rxjs';

export interface Settings {
    ServerUrl: string,
    StartupMode: string
  }

@Injectable({
    providedIn: 'root'
})
export class SettingsService {
    constructor(private storage: Storage) { }

    public async updateSettings(data: Settings){
        await this.storage.set('settings', data);
    }

    public getSettings(): Observable<Settings> {
        return from(this.storage.get('settings').then((data: Settings) => {
            return data;
        }));
    }
}